import React from 'react';
import Footer from './Footer';


const Privacy = (props) => {

    return (
        <div>
            <div className="cent-content-white">
                <div className="cent-page cent-page-formal">
                    <p>Please read this privacy notice (“Privacy Notice”) carefully as it describes our collection, use,
                        disclosure, retention and protection of your personal information. This Privacy Notice applies
                        to any website, application or service which references this Privacy Notice. Where you provide
                        us with your personal information in any of the ways described below, you agree that we may
                        collect, store and use it: (a) in order to perform our contractual obligations to you; (b) based
                        on our legitimate interests for processing (i.e. for internal administrative purposes, data
                        analytics and benchmarking (see section 3 below for more information), direct marketing,
                        maintaining automated back-up systems or for the detection or prevention of crime); or (c)
                        based on your consent, which you may withdraw at any time, as described in this Privacy
                        Notice.</p>

                    <p>This Privacy Notice applies to all products, applications and services offered by Premier IT but
                        excludes any products applications or services that have separate privacy notices which do not
                        incorporate this Privacy Notice.</p>

                    <h3>1. Definitions</h3>
                    <p>“Non Personal Information” is information that is not personally identifiable to you and that
                        we automatically collect when you use our web applications. It may also include publicly
                        available
                        information that is shared between you and others.</p>

                    <p>“Personally identifiable information” is non-public information that is personally
                        identifiable to you and obtained in order for us to provide you within our web applications.
                        Personally identifiable information may include information such as your name, email address,
                        and
                        other related information that you provide to us or that we obtain about you.</p>

                    <h3>2. How we collect information</h3>
                    <p>To the extent permissible under applicable law, we collect information about you and any other
                        party whose details you provide to us when you:</p>

                    <ul className="cent-ul-text">
                        <li>register to use our websites, applications or services (including free trials); this may
                            include
                            your name (including business name), address, email address and telephone number. We may
                            also
                            ask you to provide additional information about your business and your preferences
                        </li>

                        <li>place an order using our websites, applications or services; this may include your name
                            (including
                            business name), address, contact (including telephone number and email address) and payment
                            details
                        </li>

                        <li>complete online forms (including call back requests), take part in surveys, post on our
                            message
                            boards, post any blogs, enter any competitions or prize draws, download information such as
                            white papers or other publications or participate in any other interactive areas that appear
                            on
                            our website or within our application or service
                        </li>

                        <li>interact with us using social media</li>

                        <li>provide your contact details to us when registering to use or accessing any websites,
                            applications or services we make available or when you update those details
                        </li>

                        <li>contact us offline, for example by telephone, fax, SMS, email or post.</li>
                    </ul>
                    <p>We will also collect your information where you only partially complete and/or abandon any
                        information inputted into our website and/or other online forms and may use this information to
                        contact you to remind you to complete any outstanding information and/or for marketing purposes.
                    </p>

                    <p>We also collect information from your devices (including mobile devices) and applications you or
                        your users use to access and use any of our websites, applications or services (for example,
                        we may collect the device identification number and type, location information and connection
                        information such as statistics on your page views, traffic to and from the sites, referral URL,
                        ad data, your IP address, your browsing history and your web log information) and we will ask
                        for your permission before we do so. We may do this using cookies or similar technologies.</p>

                    <h4>Providing us with information about others</h4>
                    <p>If you provide us with personal information about someone else, you are responsible for ensuring
                        that you comply with any obligation and consent obligations under applicable data protection
                        laws
                        in relation to such disclosure. In so far as required by applicable data protection laws, you
                        must ensure that you have provided the required notices and have obtained the individual’s
                        explicit consent to provide us with the information and that you explain to them how we collect,
                        use, disclose and retain their personal information or direct them to read our Privacy
                        Notice.</p>

                    <h3>3. How we use your information</h3>
                    <p>To the extent permissible under applicable law, we use your information to:</p>

                    <ul className="cent-ul-text">
                        <li>provide any information and services that you have requested or any applications or services
                            that you have ordered
                        </li>
                        <li>compare information for accuracy and to verify it with third parties
                        </li>

                        <li>provide, maintain, protect and improve any applications, products, services and information
                            that
                            you have requested from us
                        </li>

                        <li>manage and administer your use of applications, products and services you have asked us to
                            provide;
                            manage our relationship with you (for example, customer services and support activities)
                        </li>

                        <li>monitor, measure, improve and protect our content, website, applications and services and
                            provide
                            an enhanced, personal, user experience for you
                        </li>

                        <li>undertake internal testing of our website, applications, systems and services to test and
                            improve
                            their security, provision and performance, in which case, we would pseudonymise any
                            information
                            used for such purposes, and ensure is it only displayed at aggregated levels which will not
                            be
                            linked back to you or any living individual
                        </li>

                        <li>provide you with any information that we are required to send you to comply with our
                            regulatory
                            or legal obligations
                        </li>

                        <li>detect, prevent, investigate or remediate, crime, illegal or prohibited activities or to
                            otherwise
                            protect our legal rights (including liaison with regulators and law enforcement agencies for
                            these purposes)
                        </li>

                        <li>contact you to see if you would like to take part in our customer research (for example,
                            feedback on your use of our applications, products and services)
                        </li>

                        <li>to monitor, carry out statistical analysis and benchmarking, provided that in such
                            circumstances
                            it is on an aggregated basis which will not be linked back to you or any living individual
                        </li>
                    </ul>
                    <p>To the extent permitted by applicable law, we retain information about you after the closure of
                        your account.</p>

                    <p>Our website, applications (including mobile applications) and services may contain technology
                        that enables us to:</p>

                    <ul className="cent-ul-text">
                        <li>check specific information from your device or systems directly relevant to your use of the
                            websites, applications or services against our records to make sure the websites,
                            applications
                            or services are being used in accordance with our end-user agreements and to troubleshoot
                            any problems
                        </li>
                        <li>obtain information relating to any technical errors or other issues with our website,
                            applications and services
                        </li>
                        <li>
                            collect information about how you and users use the functions of the features of our
                            website,
                            applications and services
                        </li>
                        <li>
                            gather statistical information about the operating system and environment from which you
                            access our applications or services
                        </li>
                    </ul>

                    <p>You can manage your privacy settings within your browser or our applications and services
                        (where applicable).</p>

                    <p>We may monitor and record our communications with you, including e-mails and phone conversations.
                        Information which we collect may then be used for training purposes, quality assurance, to
                        record
                        details about our website, applications and services you order from us or ask us about, and in
                        order to meet our legal and regulatory obligations generally.</p>

                    <h4>Mobile data</h4>
                    <p>We may obtain information through mobile applications that you or your users install on their
                        mobile devices to access and use our website, applications or services or which you or your
                        users
                        use to provide other services related to that mobile application (for example, to sync
                        information
                        from our application or service with such mobile application). Mobile applications may provide
                        us with information related to a user’s use of that mobile application and use of our
                        applications
                        and services accessed using that mobile application. We may use such information to provide and
                        improve the mobile application or our own application or services. For example, activity
                        undertaken within a mobile application may be logged.</p>

                    <p>You can configure our mobile application’s privacy settings on your device but this may affect
                        the performance of that mobile application and the way it interacts with our applications and
                        services.</p>

                    <h3>4. Your information and your rights</h3>
                    <p>If you are based within the EEA or within another jurisdiction having similar data protection
                        laws,
                        in certain circumstances you have the following rights:</p>

                    <ul className="cent-ul-text">
                        <li>the right to be told how we use your information and obtain access to your information
                        </li>
                        <li>the right to have your information rectified or erased or place restrictions on processing
                            your information
                        </li>
                        <li>the right to object to the processing of your information e.g. for direct marketing purposes
                            or where the processing is based on our legitimate interests
                        </li>
                        <li>
                            the right to have any information you provided to us on an automated basis returned to you
                            in a structured, commonly used and machine-readable format, or sent directly to another
                            company, where technically feasible (“data portability”)
                        </li>
                        <li>
                            where the processing of your information is based on your consent, the right to withdraw
                            that consent subject to legal or contractual restrictions
                        </li>

                        <li>
                            the right to object to any decisions based on the automated processing of your personal
                            data,
                            including profiling
                        </li>

                        <li>
                            the right to lodge a complaint with the supervisory authority responsible for data
                            protection
                            matters (e.g. in the UK, the Information Commissioner’s Office)
                        </li>
                    </ul>

                    <p>If we hold any information about you which is incorrect or if there are any changes to your
                        details,
                        please let us know by so that we can keep our records accurate and up to date.</p>

                    <p>If you withdraw your consent to the use of your personal information for purposes set out in our
                        Privacy Notice, we may not be able to provide you with access to all or parts of our website,
                        applications, and services.</p>

                    <p>We will retain your personal information for the duration of our business relationship and
                        afterwards
                        for as long as is necessary and relevant for our legitimate business purposes or as otherwise
                        permitted by applicable laws and regulations. Where we no longer need your personal information,
                        we will dispose of it in a secure manner (without further notice to you).</p>

                    <h4>Your consent</h4>
                    <p>By using this web application, you consent to the terms of our online privacy policy and to
                        Premier IT processing of personal information for the purposes given above as well as those
                        explained where Premier IT collects personal information on the web.</p>

                    <h3>5. Information sharing and disclosure</h3>
                    <p>Premier IT does not rent, sell, or share personal information about you with other people
                        (save with your consent) or non-affiliated companies. We respond to subpoenas, court orders, or
                        legal process, or to establish or exercise our legal rights or defend against legal claims;
                        We believe it is necessary to share information in order to investigate, prevent, or take action
                        regarding illegal activities, suspected fraud, situations involving potential threats to the
                        physical safety of any person, violations of Premier IT terms of use, or as otherwise required
                        by law.</p>

                    <h3>6. Confidentiality and security</h3>
                    <p>We take appropriate security measures to protect against unauthorised access to or unauthorised
                        alteration, disclosure or destruction of data. We limit access to personal information about you
                        to employees who we believe reasonably need to come into contact with that information to
                        provide
                        products or services to you or in order to do their jobs.</p>

                    <h3>7. Security and storage of information</h3>
                    <p>We will keep your information secure by taking appropriate technical and organisational measures
                        against its unauthorised or unlawful processing and against its accidental loss, destruction or
                        damage. We will do our best to protect your personal information but we cannot guarantee the
                        security of your information which is transmitted to our website, applications or services or
                        to other website, applications and services via an internet or similar connection. If we have
                        given you (or you have chosen) a password to access certain areas of our websites, applications
                        or services please keep this password safe – we will not share this password with anyone.</p>

                    <p>If you believe your account has been compromised, please contact us at privacy@premierit.com.</p>

                    <h3>8. Cookies, analytics and traffic data</h3>
                    <p>Cookies are small text files which are transferred from our websites, applications or services
                        and stored on your device. We use cookies to help us provide you with a personalised service,
                        and to help make our websites, applications and services better for you.</p>

                    <p>Our cookies may be session cookies (temporary cookies that identify and track users within our
                        websites, applications or services which are deleted when you close your browser or leave your
                        session in the application or service) or persistent cookies (cookies which enable our websites,
                        applications or services to “remember” who you are and to remember your preferences within our
                        websites, applications or services and which will stay on your computer or device after you
                        close your browser or leave your session in the application or service).</p>

                    <p>We use the following different types of cookies:</p>

                    <h4>Strictly necessary cookies</h4>
                    <p>These are cookies which are needed for our websites, applications or services to function
                        properly,
                        for example, these cookies allow you to access secure areas of our website or to remember what
                        you have put into your shopping basket.</p>

                    <h4>Performance cookies and analytics technologies</h4>
                    <p>These cookies collect information about how visitors and users use our websites, applications
                        and services, for instance which functionality visitors use most often, and if they get error
                        messages from areas of the websites, applications or services. These cookies don't collect
                        information that identifies a visitor or user. All information these cookies collect is
                        aggregated
                        and therefore anonymous. We only use these cookies to improve how our website, applications and
                        services work.</p>

                    <h4>Functionality cookies</h4>
                    <p>These cookies allow our websites, applications and services to remember choices you make (such
                        as your user name, language or the region you are in) and provide enhanced, more personal
                        features.
                        These cookies can also be used to remember changes you have made to text size, fonts and other
                        parts of web pages that you can customise. They may also be used to provide services you have
                        asked for. The information these cookies collect may be anonymised and they cannot track your
                        browsing activity on other websites.</p>

                    <h4>How to disable cookies</h4>
                    <p>You may be able to configure your browser or our website, application or service to restrict
                        cookies or block all cookies if you wish, however if you disable cookies you may find this
                        affects
                        your ability to use certain parts of our website, applications or services. For more information
                        about cookies and instructions on how to adjust your browser settings to accept, delete or
                        reject cookies, see the www.allaboutcookies.org website.</p>

                    <h3>9. Changes to our Privacy Notice</h3>
                    <p>We may change this Privacy Notice from time to time. However we will not reduce your rights under
                        this Privacy Notice. We will always update this Privacy Notice on our website, so please try to
                        read it when you visit the website (the ‘last updated’ reference tells you when we last updated
                        this Privacy Notice).</p>

                    <h3>10. Questions about our Privacy Notice</h3>
                    <p>If you have any questions about our privacy practices or this privacy notice, please contact us
                        on our dedicated support website.</p>
                    <p><a href="https://support.premierit.com" target="_blank">support.premierit.com</a></p>
                    <p><em>10th December 2018</em></p>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Privacy;